import React from "react"
import { Toaster } from "sonner"

import Router from "./components/Router"
import MaintenancePage from "./components/MaintenancePage"
import GroupContext from "./components/providers/GroupContext"
import IncidentContext from "./components/providers/IncidentContext"
import InspectionContext from "./components/providers/InspectionContext"
import IssueContext from "./components/providers/IssueContext"
import {
  IdentityQueryClientProvider,
  OrganizationAccessProvider,
} from "./components/providers/OrganizationAccessProvider"

export default function App() {
  if (import.meta.env.VITE_MAINTENANCE_MODE === "true") {
    return <MaintenancePage />
  }

  return (
    <React.Fragment>
      <IdentityQueryClientProvider>
        <Toaster richColors position="top-right" />
        <OrganizationAccessProvider>
          <GroupContext>
            <IncidentContext>
              <InspectionContext>
                <IssueContext>
                  <React.Suspense fallback={<React.Fragment />}>
                    <Router />
                  </React.Suspense>
                </IssueContext>
              </InspectionContext>
            </IncidentContext>
          </GroupContext>
        </OrganizationAccessProvider>
      </IdentityQueryClientProvider>
    </React.Fragment>
  )
}

/*

SUGGESTED IMPROVEMENTS for refreshing the session:

React.useEffect(() => {
  if (authenticating) return
  if (!loggedInUser?.id) return

  const timeout = setTimeout(async () => {
    try {
      // Use refresh token instead of credentials
      const refreshToken = localStorage.getItem('refreshToken')
      if (!refreshToken) {
        toast.error("Session expired. Please login again.")
        setLoggedInUser(null)
        return
      }

      const { status, data } = await refreshUserSession(refreshToken)

      if (status !== 200) {
        toast.error("Session expired. Please login again.")
        setLoggedInUser(null)
        return
      }

      // Update user data and store new tokens
      setLoggedInUser(data.user)
      localStorage.setItem('refreshToken', data.refreshToken)
    } catch (error) {
      toast.error("Failed to refresh session. Please check your internet connection.")
      console.error(error)
    }
  }, reauthenticateInterval)

  return () => clearTimeout(timeout)
}, [loggedInUser, authenticating, setLoggedInUser])

NEED A NEW ENDPOINT:

export async function refreshUserSession(refreshToken: string) {
  const response = await fetch('/api/refresh-token', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ refreshToken }),
  })

  const data = await response.json()
  return { status: response.status, data }
}

You'll need to update your backend to:
Generate both access and refresh tokens at login
Add a refresh token endpoint that validates the refresh token and issues new access tokens
Store refresh tokens securely (usually in a database with user association)
Implement token revocation capabilities

*/
